// src/pages/EmailLinkHandler.jsx
import React, { useEffect, useState } from 'react';
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { toast, Bounce } from 'react-toastify';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { findUser } from '../api/userApi';
import { useAuth } from '../context/AuthContext';

export default function EmailLinkHandler() {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {setUserData} = useAuth();

  useEffect(() => {
    const auth = getAuth();
    const link = window.location.href;
  const CheckUserFromServer =async (user) =>{ 
    try {
      const loginuser = await findUser(user.email);
      if (loginuser) {
        setUserData(loginuser);
      navigate(`/`);
    }
    } catch (findErr) {
      if (findErr?.response?.data?.error !== "User not found.") {
        navigate(`/register`); //complete registration
      }
    }
  }
    // 1) Make sure this is a valid email‑link callback
    if (!isSignInWithEmailLink(auth, link)) {
      toast.error(t('invalidOrExpiredLink'), { transition: Bounce });
      navigate('/register');
      return;
    }

    // 2) Retrieve the user’s email from localStorage (where we saved it)
    let email = window.localStorage.getItem('emailForSignIn');
    if (!email) {
      email = window.prompt(t('enterEmailForVerification')); 
      // fallback if they cleared storage
    }

    // 3) Complete the sign‑in
    signInWithEmailLink(auth, email, link)
      .then(({ user }) => {
        window.localStorage.removeItem('emailForSignIn');
        // stash for the profile‑form to pick up
        window.localStorage.setItem('regEmail', user.email);
        CheckUserFromServer(user);   

      })
      .catch(err => {
        console.error(err);
        if (err.code === 'auth/email-already-in-use') {
          toast.error(t('emailAlreadyInUse'), { transition: Bounce });
          
        } else if (err.code === 'auth/invalid-action-code') {
          toast.error(t('linkExpired'), { transition: Bounce });
          
        } else {
          toast.error(err.message || t('verificationError'), { transition: Bounce });
        }
      })
      .finally(() => setLoading(false));
  }, [navigate, t]);

  // spinner while we do our checks
  return loading
    ? <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin w-8 h-8 text-[#ff8000]" />
      </div>
    : null;
}
